import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter, ViewEncapsulation, HostListener } from '@angular/core';
import { ClassService } from 'src/app/core/services/class.service';

@Component({
  selector: 'app-list-filter',
  templateUrl: './list-filter.component.html',
  styleUrls: ['./list-filter.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('mWebFilterDialog', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(200)
      ]),
      transition('* => void', [
        animate(200, style({ transform: 'translateX(100%)' }))
      ])
    ])
  ]
})
export class ListFilterComponent implements OnInit, OnChanges {
  @Input() filterList: Array<any> = [];
  @Input() crntRecordType: string;
  @Input() staticFilterList: Array<string> = [];
  @Input() isStaticfilter = false;
  @Input() isChangeLableOnSelect = false;
  @Input() isApplyBorder: boolean = false;
  @Output() changeFilter: EventEmitter<any> = new EventEmitter<any>();
  @Input() mobFilter: boolean;
  public filterApply: any = {};

  public isShownMobFilter: boolean = false;

  public filter: any = {}

  public selectedFilters: any = {}
  mobfilterstatus: boolean = false;
  selectValueIndex: any;
  activeFilter = {
    subjects: false,
    languages: false,
    days: false,
    type: false
  }

  constructor(private classService: ClassService) { }

  ngOnInit(): void {
    if (this.isStaticfilter) {
      this.staticFilterList.forEach((e: string) => {
        switch (e) {
          case 'type':
            this.filterList.push(
              {
                "name": "type",
                "key": "type",
                "multiselect": false,
                "values": [
                  { id: 'allCourse', name: 'all courses', isSelected: true },
                  { id: 'freeCourse', name: 'Free Courses', isSelected: false },
                  { id: 'fullYearCourse', name: 'Full-year Courses', isSelected: false },
                  { id: 'crashCourse', name: 'Crash Courses', isSelected: false },
                  { id: 'microCourse', name: 'Micro-courses', isSelected: false }
                ]
              }
            );
            break;

          case 'subjects':
            this.filterList.push(
              {
                "name": "subjects",
                "key": "subjects",
                "multiselect": true,
                "values": [
                  { id: 'MATH', name: 'Maths', isSelected: false },
                  { id: 'CHEM', name: 'chemistry', isSelected: false },
                  { id: 'PHY', name: 'physics', isSelected: false },
                  { id: 'BIOL', name: 'biology', isSelected: false },
                  { id: 'ZOOL', name: 'zoology', isSelected: false },
                  { id: 'BOTA', name: 'botany', isSelected: false }
                ]
              }
            );
            break;

          case 'days':
            this.filterList.push(
              {
                "name": "days",
                "key": "days",
                "multiselect": false,
                "values": [
                  { id: 'all', name: 'All Days', isSelected: false },
                  { id: 'weekends', name: 'Weekends', isSelected: false },
                  { id: 'weekdays', name: 'Weekdays', isSelected: false }
                ]
              }
            );
            break;

          case 'languages':
            this.filterList.push(
              {
                "name": "languages",
                "key": 'languages',
                "multiselect": true,
                "values": [
                  { id: 'english', name: 'english', isSelected: false },
                  { id: 'hindi', name: 'hindi', isSelected: false }
                ]
              }
            );
            break;
        }
      });
    }


    this.filterList.map(v=> v.name == 'types'? v.name = 'type' :  v.name);

    this.filterList.map((v:any)=> !v.key ?  v.key = v?.name : '');

    setTimeout(()=>{
      if(this.isChangeLableOnSelect) {
        this.onInitFilterUpdate();
      }
    }, 1000);

    console.log('FFFFFFFFFFFFFFFFFFFFFFFFFFFF', this.filterList);
    this.classService.clearAllFilter.subscribe((res: any) => {
      if (res && res.val1 === 'clear' && res.val2 === true) {
        this.clearAllFilter();
      } else if (res && res.val1 === 'apply' && res.val2 === true) {
        this.applyMobileFilter();
      }
    })
  }

  ngOnChanges(_changes: SimpleChanges): void {
    console.log("ngOnChanges: ", _changes)
    this.activeFilter.days = false;
    this.activeFilter.languages = false;
    this.activeFilter.subjects = false;
    this.activeFilter.type = false;
  }

  // toogleMobFilterTab = () => {
  //   this.isShownMobFilter = !this.isShownMobFilter;
  //   if (this.isShownMobFilter) {
  //     document.body.classList.add('no-scroll');
  //   } else {
  //     document.body.classList.remove('no-scroll');
  //   }
  // }

  onInitFilterUpdate = () => {
    if(this.filterList?.length > 0) {
      for(const item of this.filterList) {
        if (item.multiselect) {
          let filteredValue = item.values.filter((x: any) => x.isSelected == true && x.id).map((x: any) => x.id)

          if (filteredValue?.length > 0) {
            this.filterApply[item.name == 'languages' ? 'language' : item.name] = filteredValue
          } else {
            delete this.filterApply[item.name == 'languages' ? 'language' : item.name]
          }

        } else {
          let _selectedItems = item.values.filter((x: any) => x.isSelected == true && x.id).map((x: any) => x.id);
          if(_selectedItems.length > 0) {
            if(item.key && item.key != undefined) {
              this.filterApply[item.key] = _selectedItems;
            } else {
              this.filterApply[item.name] = _selectedItems;
            }
          } else {
            if(item.key && item.key != undefined) {
              delete this.filterApply[item.key];
            } else {
              delete this.filterApply[item.name];
            }
          }
        }
      }
      this.updateFilterLabel();
    }
  }

  onFilterChange(_event: any, item: any, ind: number) {
    if (item.multiselect) {
      item.values = item.values.map(
        (x: any) => {
          var _obj: any = Object.assign({}, x);
          _obj.isSelected = _obj.id == _event.target.value ? !_obj.isSelected : _obj.isSelected;
          return _obj;
        }

      )
      this.filterList.map(val => val.name == item.name ? val.values = item.values : val.values)

      let filteredValue = item.values.filter((x: any) => x.isSelected == true && x.id).map((x: any) => x.id)

      if (filteredValue?.length > 0) {
        this.filterApply[item.name == 'languages' ? 'language' : item.name] = filteredValue
      } else {
        delete this.filterApply[item.name == 'languages' ? 'language' : item.name]
      }
      // if (this.filterApply?.subjects && this.filterApply?.subjects?.length) {
      //   this.activeFilter.subjects = true;
      // } else {
      //   this.activeFilter.subjects = false;
      // }
      this.activeFilter.subjects = this.filterApply?.subjects && this.filterApply?.subjects?.length ? true : false;
      this.activeFilter.languages = this.filterApply?.language && this.filterApply?.language?.length ? true : this.filterApply?.languages && this.filterApply?.languages?.length ? true : false;
      console.log(this.activeFilter);
    } else {
      item.values = item.values.map(
        (x: any) => {
          var _obj: any = Object.assign({}, x);
          _obj.isSelected = _obj.id == _event.target.value ? true : false;
          return _obj;
        }
      )
      this.filterList.map(val => val.name == item.name ? val.values = item.values : val.values)
      // if(item.key && item.key != undefined) {
      //   this.filterApply[item.key] = item.values.filter((x: any) => x.isSelected == true && x.id).map((x: any) => x.id)
      // } else {
      //   this.filterApply[item.name] = item.values.filter((x: any) => x.isSelected == true && x.id).map((x: any) => x.id)
      // }
      let _selectedItems = item.values.filter((x: any) => x.isSelected == true && x.id).map((x: any) => x.id);
      if(_selectedItems.length > 0) {
        if(item.key && item.key != undefined) {
          this.filterApply[item.key] = _selectedItems;
        } else {
          this.filterApply[item.name] = _selectedItems;
        }
      } else {
        if(item.key && item.key != undefined) {
          delete this.filterApply[item.key];
        } else {
          delete this.filterApply[item.name];
        }
      }this.activeFilter.days = this.filterApply?.days && this.filterApply?.days?.length ? true : false;
      this.activeFilter.type = this.filterApply?.type && this.filterApply?.type?.length ? true : false;
      console.log(this.filterApply);
    }
    if (!this.mobFilter) {
      window.scrollTo(0, 100);
      this.changeFilter.emit(this.filterApply);
  
      if(this.isChangeLableOnSelect) {
        this.updateFilterLabel();
      }
    }

  }

  updateFilterLabel = () => {
    let _selectedOpt: any = {};
    Object.keys(this.filterApply).forEach((_item) => {
      let _filterObj = this.filterList.find((x:any) => x?.name?.toLowerCase() == _item || x?.key?.toLowerCase() == _item );

      let _filterName = '' //_filterObj.name;
      if(_filterObj?.multiselect) {
        _filterName = _filterObj.name + " (" + this.filterApply[_item].length + ")";
      } else {
        let _selectedId = this.filterApply[_item].join('');

        let _selectedValue = _filterObj.values.find((x:any) => x?.id == _selectedId);

        if(_item == 'grade' && _selectedValue.id) {
          _filterName = 'Grade ' + this.filterApply[_item].join('');
        } else {
          _filterName = _selectedValue.name;
        }
      }

      _selectedOpt[_item] = _filterName;
    })
    this.selectedFilters = _selectedOpt;
  }

  clear() {
    this.filterList.map(v=> {
      if(v.name == 'subjects') {
        v.values.forEach(ele => ele.isSelected = false);
      }
    });
    this.filterApply = {};
    window.scrollTo(0, 100);
    this.changeFilter.emit(this.filterApply);
    this.activeFilter.subjects = false;
  }

  clearAllFilter() {
    this.filterList.map(v=> {
      if(v.name == 'subjects' || v.name == 'days' || v.name == 'languages') {
        v.values.forEach(ele => ele.isSelected = false);
      }
    });
    this.filterApply = {};
    window.scrollTo(0, 100);
    this.changeFilter.emit(this.filterApply);
  }

  applyMobileFilter() {
    window.scrollTo(0, 100);
      this.changeFilter.emit(this.filterApply);
      if(this.isChangeLableOnSelect) {
        this.updateFilterLabel();
      }
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.closeFilterPopupOnResize();
  }

  closeFilterPopupOnResize = () => {
    this.mobfilterstatus = false;
  }
}
